import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Select,
  Card,
  Button,
  Spin,
  Alert,
  Input,
  notification,
  Table,
  Col,
} from 'antd';
import {LotCodeOpsService,ProductConversionService,ProductionInventoryService} from '@gtpl/shared-services/production';
import Highlighter from 'react-highlight-words';
import {
 
  EyeOutlined,
  EditOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, Redirect } from 'react-router-dom';
// import './product-convertion-grid.css';
import { ColumnProps, ColumnsType } from 'antd/lib/table';
import { GRNLocationPropsRequest } from '@gtpl/shared-models/masters';
import { PackingIndentService, StockService, StoreConsumptionService } from '@gtpl/shared-services/procurement';
import moment from 'moment';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ProductConversionDetailsDTO, ProductConversionDTO } from '@gtpl/shared-models/production-management';

/* eslint-disable-next-line */

export interface ProductConvertionGridProps {}

export function ProductConvertionGrid(props: ProductConvertionGridProps) {
  const Option = Select;
  // const service = new GrnService();
  const [grndata, setGrndata] = useState<any[]>([]);
  const [locationData, setLocationData] = useState<GRNLocationPropsRequest>();
  const [productConversion, setProductConversion] = useState<ProductConversionDetailsDTO[]>([]);
  const [pageSize, setPageSize] = useState<number>(null);
  const [page, setPage] = React.useState(1);
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const productConversionService = new ProductConversionService();

  useEffect(() => {
    getProductConversion();
  }, []);

  const getProductConversion = () => {
    productConversionService.getProductConversionDetails({unitcodeId:Number(localStorage.getItem("unit_id"))}).then(res => {
      if (res.status) {
        setProductConversion(res.data);
      } else {
        if (res.intlCode) {
          setProductConversion([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setProductConversion([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? '#1890ff' : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  }

  
  const sampleTypeColumns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '60px',
      responsive: ['sm'],
      render: (text, object, index) => (page - 1) * pageSize + (index + 1),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      width: '100px',
      render: (text, record) => { return moment(record.date).format('YYYY-MM-DD') },
      sorter: (a, b) => a.date - b.date,
      sortDirections: ['descend', 'ascend'],
      responsive: ['sm'],
      // ...getColumnSearchProps('vendorName'),
    },
    {
      title: 'Plant',
      dataIndex: 'plant',
      align: 'left',
      ...getColumnSearchProps('plant'),
    },
    {
      title: 'Lot Code',
      dataIndex: 'concatLotNum',
      align: 'left',
      ...getColumnSearchProps('concatLotNum'),
    },
    {
      title: 'From : Product(So & So Item)',
      dataIndex: 'fromSaleOrder',
      align: 'left',
      ...getColumnSearchProps('fromProduct'),
    },
    {
      title: 'To  : Product(So & So Item)',
      dataIndex: 'toSaleOrder',
      align: 'left',
      ...getColumnSearchProps('toProduct'),
    },
    {
      title: 'Reason ',
      dataIndex: 'reason',
      align: 'left',
      ...getColumnSearchProps('vendorName'),
    },
    {
      title: 'boxes ',
      dataIndex: 'boxes',
      align: 'left',
      sorter: (a, b) => a.boxes - b.boxes,
      sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('boxes'),
    },
    {
      title: 'Quantity ',
      dataIndex: 'quantity',
      align: 'left',
      sorter: (a, b) => a.quantity - b.quantity,
      sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('quantity'),
    },
  ];

  return (
    <div>
      <Card title={<span style={{ color: 'white' }}>Product conversion</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={<Link to="/production-convertion-form" ><Button className='panel_button' >Product Conversion</Button></Link>}>
        <Table
          rowKey={(record) => record.productId}
          className="components-table-nested"
          columns={sampleTypeColumns}
          dataSource={productConversion}
          scroll={{ x: 500 }}
          bordered
        />
      </Card>
    </div>
  );
}

export default ProductConvertionGrid;
